'use client';
import ExpireLinkNotFound from '@/components/not-found/expire-link-not-found';
import NotFoundView from '@/features/layouts/errors';
import { useSearchParams } from 'next/navigation';

export default function NotFoundPage() {
  const searchParams = useSearchParams();
  const expireLink = searchParams.get('expire-link');

  if (expireLink) {
    return <ExpireLinkNotFound />;
  }

  return <NotFoundView />;
}
